export default "__VITE_ASSET__CtzmvPG4__"